'use client';

import { useEffect, useState } from 'react';

import { useQuery, useApolloClient } from '@apollo/client/react';
import type { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';

import { WidgetsApp } from '@/components';
import { Types } from '@scorenco/core';
import { resolveTeamId } from '@/utils/teamIdResolver';

import { TeamWidget } from '../../../components/Widgets';
import { GetTeamDetailsDocument } from '../../_internal/Widget.query.generated';

const Team = () => {
  const router = useRouter();
  const hasNoParams = !router.query.showRanking && !router.query.showEvents;
  const showRanking = hasNoParams || router.query.showRanking !== undefined;
  const showEvents = hasNoParams || router.query.showEvents !== undefined;
  const showHeader = router.query.showHeader;
  const client = useApolloClient();
  const [resolvedTeamId, setResolvedTeamId] = useState<number>();

  // Pour les widgets MonSiteClub avec l'ancien ID
  useEffect(() => {
    if (router.query.teamId) {
      resolveTeamId(router.query.teamId, client)
        .then(setResolvedTeamId)
        .catch(console.error);
    }
  }, [router.query.teamId, client]);

  const getTeamDetail = useQuery(GetTeamDetailsDocument, {
    variables: {
      teamId: resolvedTeamId!,
      cacheTTL: router.query.noCache ? 0 : undefined,
    },
    skip: !resolvedTeamId,
    context: {
      role: 'anonymous',
    },
  });

  const team = getTeamDetail.data?.teams_team_detail_by_team_id?.[0];

  return (
    <WidgetsApp
      widget={{
        __typename: 'widgets_widget',
        id: 0,
        settings: getTeamDetail.data?.widgets_club_settings?.[0] as
          | Types.Widgets_Club_Settings
          | undefined,
      }}
      noAds
    >
      <TeamWidget
        teams={team ? [team as Types.Teams_Team_Detail] : undefined}
        settings={{
          show_ranking: showRanking,
          show_events: showEvents,
        }}
        show_header={Number(showHeader) !== 0}
      />
    </WidgetsApp>
  );
};

export const getStaticPaths: GetStaticPaths = () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'fr', [
      'snc-components',
      'snc-core',
      'common',
    ])),
  },
});

export default Team;
